import React from 'react';
import { Body, Button, styled } from '@teko/ds-desktop';
import { SizeEnum } from '@teko/types/ds';
import locationImg from '../../assets/images/location.es.js';
import { t } from '../../i18n.es.js';
import { SelectionOption } from '../SelectionOption/SelectionOption.es.js';
import { useDevice } from '../../contexts/DeviceContext.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const RegionPicker = (_a) => {
  var _b = _a, {
    value,
    onChange,
    onSubmit,
    title,
    options
  } = _b, rest = __objRest(_b, [
    "value",
    "onChange",
    "onSubmit",
    "title",
    "options"
  ]);
  const { isMobile } = useDevice();
  return /* @__PURE__ */ React.createElement(Wrapper, __spreadValues({}, rest), /* @__PURE__ */ React.createElement("div", {
    style: { marginBottom: 12, textAlign: "justify" }
  }, typeof title === "string" ? /* @__PURE__ */ React.createElement(Body, {
    level: 1
  }, title) : title), /* @__PURE__ */ React.createElement(ImgWrapper, {
    src: locationImg,
    alt: "choose location"
  }), options.map((el) => {
    return /* @__PURE__ */ React.createElement(StyledSelectionOption, {
      key: el.value,
      isActive: value === el.value,
      onClick: () => {
        onChange(el.value);
      },
      iconActiveSize: SizeEnum.s
    }, el.text);
  }), /* @__PURE__ */ React.createElement(Button, {
    variant: "primary",
    size: isMobile ? "s" : "m",
    block: true,
    onClick: () => onSubmit(value)
  }, t("X\xE1c nh\u1EADn")));
};
const Wrapper = styled.div`
  text-align: center;
`;
const ImgWrapper = styled.img`
  margin: 32px;
`;
const StyledSelectionOption = styled(SelectionOption)`
  margin-bottom: 4px;
`;

export { RegionPicker };
